
    import { computed, defineComponent } from 'vue'

    import LogoAghMine from '@/common/components/logo/LogoAghMine.vue'
    import LogoAghBis from '@/common/components/logo/LogoAghBis.vue'
    import LogoAghKsaf from '@/common/components/logo/LogoAghKsaf.vue'

    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        components: {
            LogoAghBis,
            LogoAghKsaf,
            LogoAghMine
        },

        props: {
            simple: {
                type: Boolean,
                default: false
            }
        },

        setup () {
            const settingsStore = useSharedSettingsStore()
            const bisUrl = computed(() => settingsStore.setting('cm-bis'))
            const ksafUrl = computed(() => settingsStore.setting('cm-ksaf'))
            const mediaCenterUrl = computed(() => settingsStore.setting('cm-cm'))
            const mineUrl = computed(() => settingsStore.setting('cm-mine'))

            return {
                bisUrl,
                ksafUrl,
                mediaCenterUrl,
                mineUrl
            }
        }
    })
